import { render } from "./WallComponent.vue?vue&type=template&id=aace2088&scoped=true"
import script from "./WallComponent.vue?vue&type=script&lang=js"
export * from "./WallComponent.vue?vue&type=script&lang=js"

import "./WallComponent.vue?vue&type=style&index=0&id=aace2088&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aace2088"]])

export default __exports__